import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBarcode: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"barcode, qr code, scan"} maskId="square-filled-radius-0-stroke-1-IconBarcode"><path fillRule="evenodd" clipRule="evenodd" d="M2 4H8V5H3V10.1724H2V4ZM16 4H22V10.1724H21V5H16V4ZM8 9V15H7V9H8ZM12.5 9V13H11.5V9H12.5ZM17 9V15H16V9H17ZM3 13.8276V19L8.13514 19V20L2 20V13.8276H3ZM22 13.8276V20H16V19H21V13.8276H22Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBarcode;
